import { SORT_ORDER } from '@evinced-private/ui-common';

import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import { RUN_ID_PARAM_NAME } from 'src/common/services/queries/CommonParams';
import {
	IssuesSortFields,
	IssuesSortOrder,
	IssuesTextSearchFields
} from 'src/common/types/graphql.generated';

import { IGeWfaSessionAllIssuesParams } from '../../../WfaDashboardServiceTypes';
import { WfaSessionIssuesQueryVariables } from '../WfaSessionIssues.generated';

const issuesSortFieldNamesMap: Record<string, IssuesSortFields> = {
	type: IssuesSortFields.TypeName,
	severity: IssuesSortFields.SeverityName,
	url: IssuesSortFields.Url,
	pageTitle: IssuesSortFields.PageTitle
};

const issuesSortOrderMap: Record<SORT_ORDER, IssuesSortOrder> = {
	[SORT_ORDER.ASC]: IssuesSortOrder.Ascending,
	[SORT_ORDER.DESC]: IssuesSortOrder.Descending
};

const issuesSearchFields = [
	IssuesTextSearchFields.TypeName,
	IssuesTextSearchFields.ElementsComponentId,
	IssuesTextSearchFields.ElementsSelector,
	IssuesTextSearchFields.SeverityName,
	IssuesTextSearchFields.Url,
	IssuesTextSearchFields.PageTitle
];

const URL_FILTER_PARAM_NAME = 'urlFilter';
const TYPE_ID_FILTER_PARAM_NAME = 'typeIdFilter';
const SEVERITY_ID_FILTER_PARAM_NAME = 'severityIdFilter';
const LEVEL_FILTER_PARAM_NAME = 'levelFilter';

export const buildSessionIssuesVariables = ({
	sessionId,
	filterOptions,
	sort,
	page = 0,
	pageSize = 10
}: IGeWfaSessionAllIssuesParams): WfaSessionIssuesQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<WfaSessionIssuesQueryVariables>({
		searchFields: issuesSearchFields,
		sortFieldsMap: issuesSortFieldNamesMap,
		sortOrderMap: issuesSortOrderMap
	});

	const variables = variablesBuilder
		.addPaginationParams(page, pageSize)
		.addSortParam(sort)
		.addTextSearchParam(filterOptions?.searchValue ?? '')
		.addConditionParam(RUN_ID_PARAM_NAME, sessionId)
		.addFilterParam(URL_FILTER_PARAM_NAME, filterOptions?.urls)
		.addFilterParam(TYPE_ID_FILTER_PARAM_NAME, filterOptions?.types)
		.addFilterParam(SEVERITY_ID_FILTER_PARAM_NAME, filterOptions?.severities)
		.addFilterParam(LEVEL_FILTER_PARAM_NAME, filterOptions?.levels)
		.getVariables();

	return variables;
};
